/**
 * PostHog feature flag keys shared between client and server code.
 *
 * This module must stay dependency-free so API handlers can import flag
 * names without dragging client-only modules into the server bundle.
 */

/**
 * Gates the /apply audition-onboarding wizard (LG-118) and the pricing
 * page's coaching CTA routing to it. Admins bypass via useFeatureFlag.
 * Off everywhere until the flag-ON blockers in LG-124 are cleared.
 */
export const AUDITION_WIZARD_FLAG = 'enable-audition-wizard'

/**
 * Gates the audition funnel's FAST lane (pay-first): the wizard-end
 * "Enroll now" CTA that sends an applicant straight to Stripe Checkout
 * before any call. OFF everywhere until Mike + Jon sign off (spec §8.3) —
 * with it off, the consideration lane (call first, admin unlocks payment)
 * is the only path, which is the current live behavior.
 *
 * Admins bypass via useFeatureFlag, so the lane can be previewed without
 * exposing it to applicants.
 */
export const FAST_LANE_FLAG = 'enable-fast-lane'
